export default function Container({ tag: Tag = "section", className = "", children, ...props }) {
  return (
    <Tag {...props} className={className}>
      {children}
    </Tag>
  );
}
